export class AgreeOn {
    title: string
    text: string
}
